import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1b47588c")
const _hoisted_1 = { class: "center title-1" }
const _hoisted_2 = {
  key: 0,
  class: "center padding"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "users"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_user = _resolveComponent("card-user")!
  const _component_add_user = _resolveComponent("add-user")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { class: "view-accounts" }, {
    default: _withCtx(() => [
      _createElementVNode("dig-ui-title", _hoisted_1, _toDisplayString(_ctx.$t('allAccounts')), 1),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createBlock(_component_card_user, {
                key: user.id,
                user: user
              }, null, 8, ["user"]))
            }), 128)),
            (_ctx.canAddUser)
              ? (_openBlock(), _createBlock(_component_add_user, {
                  key: 0,
                  ref: "addUserEl",
                  onAdd: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUser($event))),
                  disabled: _ctx.loadingAddUser,
                  loading: _ctx.loadingAddUser,
                  background: true
                }, null, 8, ["disabled", "loading"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}